import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguageSync } from '../hooks/useLanguageSync';

export function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const { changeLanguage } = useLanguageSync();
  const [currentLang, setCurrentLang] = useState(i18n.language);

  useEffect(() => {
    setCurrentLang(i18n.language);
  }, [i18n.language]);

  const toggleLanguage = async () => {
    const newLang = currentLang === 'de' ? 'en' : 'de';
    await changeLanguage(newLang);
    setCurrentLang(newLang);
  };

  return (
    <button
      onClick={() => toggleLanguage()}
      className="flex items-center gap-2 px-4 py-2 rounded-lg bg-white/10 hover:bg-white/20 transition-ball duration-300 border border-white/20"
      aria-label="Switch language"
    >
      <i className="ri-global-line text-lg"></i>
      <span className="font-medium uppercase">{currentLang}</span>
    </button>
  );
}